<template>
  <div class="exercise">

    <div class="exercise__content">
      <div class="header">
        <div class="header__title">
          <template v-if="editable">
            <el-input v-model="exercise.name" class="title__input" placeholder="Введите название..."/>
          </template>
          <template v-else>{{ exercise.name ? exercise.name : 'Добавить упражнение' }}</template>
        </div>

        <div v-if="editable" class="header__btn btn">
          <save-icon @click="save()" class="btn__save"/>
          <i v-if="!newItem" @click="remove()" class="btn__delete el-icon-delete"></i>
        </div>
        <div v-else @click="changeMode">
          <i class="el-icon-edit header__edit"></i>
        </div>
      </div>

      <div class="description">
        <template v-if="editable">
          <el-input
              v-model="exercise.description"
              type="textarea"
              :rows="2"
              class="description__textarea"
              placeholder="Введите описание...">
          </el-input>
        </template>
        <template v-else>{{ exercise.description }}</template>
      </div>

      <div class="times">
        <div class="times__title">Время выполнения</div>

        <template v-if="editable">
          <div class="times__edit">
            <el-input v-model="exercise.exercise_approach" class="times__input" placeholder="Количество подходов"/>
            <el-input v-model="exercise.exercise_time" class="times__input" placeholder="Выбор времени.."/>
          </div>

        </template>
        <template v-else>
          <div class="times__description">
            <i class="el-icon-trophy-1"></i>
            {{ exercise.exercise_approach }}

            <i class="times__description_offset el-icon-timer"></i>
            {{ exercise.exercise_time }}
          </div>
        </template>

      </div>

      <attached-files :files="exercise.files" :editable="editable" class="attached-files"/>

    </div>

    <el-button  v-if="!newItem && !editable" @click="editSelected" class="exercise__btn" :type="exercise.selected ? 'primary' : ''">
      <i class="el-icon-check"></i>
    </el-button>
  </div>
</template>

<script>
import SaveIcon from "@/components/icons/Save"
import AttachedFiles from "@/components/visit/complexExercises/AttachedFiles.vue"

export default {
  name: "ComplexItem",
  components: {
    SaveIcon,
    AttachedFiles
  },
  props: {
    exercise: {},
    index: {},
    newItem: {}
  },
  data() {
    return {
      selected: this.exercise.selected,
      loading: false,
      editable: !!this.newItem
    }
  },
  computed: {},
  methods: {
    editSelected() {
      this.exercise.selected = !this.exercise.selected
      this.save()
    },
    changeMode() {
      this.editable = !this.editable
    },
    save() {
      this.$emit('save')
      if (!this.newItem) this.editable = false
    },
    remove() {
      this.$emit('remove', this.index)
      if (!this.newItem) this.editable = false
    }
  }
}

</script>
<style lang="scss" scoped>
.exercise {
  //max-width: 260px;
  //padding: 10px 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  border-radius: 4px;


  &__content {
    width: 100%;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
  }

  &__btn {
    width: 44px;
    height: 44px;
    font-size: 13px!important;
    margin-bottom: 8px;
  }

}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid #E4E7ED;
  padding: 8px 12px;


  &__title {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #111111;

  }

  &__edit {
    font-size: 13px;
    line-height: 13px;

    color: #989ca6;
    cursor: pointer;

    &:hover {
      opacity: 0.5
    }
  }

  &__btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

}

.btn {
  &__save, &__delete {
    color: #111;
    cursor: pointer;
    font-size: 13px;

    &:hover {
      opacity: 0.5
    }
  }

  &__delete {
    margin-left: 8px;
  }

}


.title {
  margin-top: 12px;

  font-weight: 600;
  font-size: 17px;
  line-height: 22px;

  color: #111;

  &__input {
    /deep/ input {
      padding: 18px 15px !important;
      font-style: normal;
      font-weight: 600;
      font-size: 17px;
      line-height: 29px;
    }
  }
}

.description {
  margin-top: 4px;
  padding: 8px 12px;

  font-size: 13px;
  line-height: 16px;
  color: #111;

  &__textarea {
    /deep/ textarea {


      color: #111;
    }
  }


}


.times {
  margin-top: 12px;
  padding: 0 12px;

  &__title {
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;

    color: #111;
  }

  &__description {
    margin-top: 5px;

    font-size: 12px;
    line-height: 13px;
    color: #078065;

    &_offset {
      margin-left: 5px;
    }
  }

  &__edit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px -5px 0 -5px;
  }

  &__input {
    margin: 0 5px;
  }

}
.attached-files {
  padding: 0 12px;
}
</style>